/**
 * scroll to ID
 */

export default function scrollToID() {
    const selectors = {
        'scrolltoid': '.js-scrolltoid',
        'nav': '.js-nav',
        'target': '.js-target',
    };

    this.init = () => {
        const navs = document.querySelectorAll(selectors.scrolltoid);
        navs.forEach(function (itemNav) {
            const jsnavs = itemNav.querySelectorAll(selectors.nav);
            const targets = itemNav.querySelectorAll(selectors.target);

            jsnavs.forEach((navItem) => {
                const link = navItem.querySelector('a') ? navItem.querySelector('a') : navItem;
                link.addEventListener('click', function (e) {
                    e.preventDefault();
                    const targetScroll = link.dataset?.scroll;
                    targets.forEach((targetItem) => {
                        if (targetItem.id == targetScroll) {
                            scrollHandle(targetItem);
                        }
                    })
                    // console.log(link.dataset?.scroll || link.href);
                })
            })


        })

        function scrollHandle(target) {
            let topFeatured = 0;

            if (target) {
                let parentFeatured = target.offsetParent;
                let count = 0;
                while (parentFeatured.nodeName !== "BODY" && parentFeatured.nodeName !== "HTML" && count < 100) {
                    topFeatured += parentFeatured.offsetTop;
                    parentFeatured = parentFeatured.offsetParent;
                    count++;
                }
                topFeatured += target.offsetTop;
            }

            const header = document.querySelector('header');
            if (header) {
                topFeatured -= header.clientHeight;
            }

            window.scrollTo({
                top: topFeatured,
                left: 0,
                behavior: "smooth"
            })
        }
    }
}